import { render, staticRenderFns } from "./jingdianchufang.vue?vue&type=template&id=22f72c2c&scoped=true&"
import script from "./jingdianchufang.vue?vue&type=script&lang=ts&"
export * from "./jingdianchufang.vue?vue&type=script&lang=ts&"
import style0 from "./jingdianchufang.vue?vue&type=style&index=0&id=22f72c2c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f72c2c",
  null
  
)

export default component.exports